document.addEventListener('DOMContentLoaded', function() {
  console.log("Let's go!!! ");

  // add box shadow when scrolling header
  document.addEventListener('scroll', () => {
    const header = document.querySelector('header header-component#header-component');
    const scrollY = window.scrollY || document.documentElement.scrollTop;

    if (scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });


  // append whasatapp button
  function appenWa () {
    let wasection = document.querySelector('.whatsapp-block-section');
    let wacontainer = document.querySelector('.waBtn_container');
    wacontainer.append(wasection);
    wacontainer.parentElement.classList.add('wabtnwrappersec');
    wacontainer.parentElement.style.width = "100%";
    console.log('appenwa running')
  }
  setTimeout(() => {
    appenWa();
  }, 0);


});
